// React
import { useEffect, useState } from "react";

// APIs
import { getClientPortalCompanies } from "api/companies.jsx";

// Utils
import { setClientCompanyIds } from "utils/auth.jsx";

/**
 * Companies the logged-in client (CU) user can switch between in the read-only portal.
 * The list is refreshed from the backend on mount and saved to localStorage, so the
 * route guard picks up companies linked (or revoked) after login.
 *
 * @returns {{ companies: Array<{id: string, name: string}>, isLoading: boolean }}
 */
const useClientPortalCompanies = () => {
  const [companies, setCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchCompanies = async () => {
      setIsLoading(true);
      try {
        const response = await getClientPortalCompanies();
        const list = Array.isArray(response?.data) ? response.data : [];
        if (cancelled) return;
        setCompanies(list);
        setClientCompanyIds(list.map((company) => company.id));
      } catch (err) {
        // Non blocking: the portal still works on the ids saved at login
        console.error("Failed to fetch client portal companies:", err);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };
    fetchCompanies();
    return () => {
      cancelled = true;
    };
  }, []);

  return { companies, isLoading };
};

export default useClientPortalCompanies;
